import { Controller, useFormContext } from 'react-hook-form';
import { FormField } from '../../../../../components/form/FormField';
import { CustomFormattedMessage } from '../../../../../i18n/i18n';
import Select, { SelectOption } from '@rio-cloud/rio-uikit/Select';
import Spinner from '@rio-cloud/rio-uikit/Spinner';
import { AddNewServiceCardForm } from './AddNewServiceCardForm';
import { ReactNode } from 'react';
import classNames from 'classnames';

type CardSelectionDropdownProps = {
  isLoading: boolean;
  options: SelectOption[];
  errorContent: ReactNode | null;
  noCardsContent: ReactNode | null;
};

export const CardSelectionDropdown = ({
  isLoading,
  options,
  errorContent,
  noCardsContent,
}: CardSelectionDropdownProps) => {
  const { control, formState } = useFormContext<AddNewServiceCardForm>();
  const fieldError = formState.errors.selectedCardId;

  return (
    <div
      className="col-xs-12"
      data-testid={'onboarding-dialog-card-options-select'}
    >
      <Controller
        name={'selectedCardId'}
        render={({ field: { onChange, value } }) => (
          <FormField
            hasError={!!fieldError}
            errorMessage={
              <CustomFormattedMessage
                id={
                  'onboarding.dialog.serviceCardForm.serviceCardNumber.errorMessage'
                }
              />
            }
          >
            {isLoading ? (
              <Spinner isDoubleSized />
            ) : (
              <>
                <label>
                  <CustomFormattedMessage id={'common.card.selectCard'} />
                </label>

                <Select
                  placeholder={
                    <CustomFormattedMessage
                      id={
                        'onboarding.dialog.paymentMethodDetails.selectCardTypePlaceholder'
                      }
                    />
                  }
                  options={options}
                  onChange={(input) => {
                    onChange(input?.id);
                  }}
                  value={value ? [value.toString()] : []}
                  disabled={!!errorContent || options.length === 0}
                />
                {(errorContent || noCardsContent) && (
                  <div
                    className={classNames('padding-top-15', {
                      'text-color-danger': !!errorContent,
                      'text-color-info': !!noCardsContent,
                    })}
                    data-testid={'onboarding-dialog-card-list-error-section'}
                  >
                    {errorContent}
                    {noCardsContent}
                  </div>
                )}
              </>
            )}
          </FormField>
        )}
        control={control}
        rules={{
          required: true,
        }}
      />
    </div>
  );
};
